export default __webpack_public_path__ + "static/media/logo-alt.9bb483b1.png";